import {Action} from "redux";
import {
    CreateCustomerRequest,
    LoginRequest,
    PasswordResetRequest,
    ApplyClientRequest, OnAuthListenerRequest, OffAuthListenerRequest
} from "../request/auth_request";
import {
    CreateCustomerResponse,
    GetMeResponse,
    LoginResponse, OffAuthListenerResponse, OnAuthListenerResponse, ObserveAuthListenerResponse
} from "../response/auth_response";

export enum AuthActionType {

    OBSERVE_AUTH_LISTENER = "AUTH_OBSERVE_AUTH_LISTENER",

    REQUEST_ON_AUTH_LISTENER = "AUTH_REQUEST_ON_AUTH_LISTENER",
    CALLBACK_ON_AUTH_LISTENER = "AUTH_CALLBACK_ON_AUTH_LISTENER",

    REQUEST_OFF_AUTH_LISTENER = "AUTH_REQUEST_OFF_AUTH_LISTENER",
    CALLBACK_OFF_AUTH_LISTENER = "AUTH_CALLBACK_OFF_AUTH_LISTENER",

    REQUEST_LOGIN = "AUTH_REQUEST_LOGIN",
    CALLBACK_LOGIN = "AUTH_CALLBACK_LOGIN",

    REQUEST_LOGOUT = "AUTH_REQUEST_LOGOUT",
    CALLBACK_LOGOUT = "AUTH_CALLBACK_LOGOUT",

    REQUEST_PASSWORD_RESET = "AUTH_REQUEST_PASSWORD_RESET",
    CALLBACK_PASSWORD_RESET = "AUTH_CALLBACK_PASSWORD_RESET",

    REQUEST_CREATE_CUSTOMER = "AUTH_REQUEST_CREATE_CUSTOMER",
    CALLBACK_CREATE_CUSTOMER = "AUTH_CALLBACK_CREATE_CUSTOMER",

    REQUEST_APPLY_CLIENT = "AUTH_REQUEST_APPLY_CLIENT",
    CALLBACK_APPLY_CLIENT = "AUTH_CALLBACK_APPLY_CLIENT",

    // GET_LOGIN_USERをポーリングしてしまうとオブサーバーを複数登録してしまうため
    // 単純にstoreを更新する用のアクションを用意する
    REQUEST_GET_ME = "AUTH_REQUEST_GET_ME",
    CALLBACK_GET_ME = "AUTH_CALLBACK_GET_ME",

}

export interface IObserveAuthListenerAction extends Action {
    type: AuthActionType.OBSERVE_AUTH_LISTENER;
    isSuccess: boolean;
    item?: ObserveAuthListenerResponse,
}

export interface IRequestOnAuthListenerAction extends Action {
    type: AuthActionType.REQUEST_ON_AUTH_LISTENER;
    item: OnAuthListenerRequest;
}
export interface ICallbackOnAuthListenerAction extends Action {
    type: AuthActionType.CALLBACK_ON_AUTH_LISTENER;
    isSuccess: boolean;
    item?: OnAuthListenerResponse;
}

export interface IRequestOffAuthListenerAction extends Action {
    type: AuthActionType.REQUEST_OFF_AUTH_LISTENER;
    item: OffAuthListenerRequest;
}
export interface ICallbackOffAuthListenerAction extends Action {
    type: AuthActionType.CALLBACK_OFF_AUTH_LISTENER;
    isSuccess: boolean;
    item?: OffAuthListenerResponse;
}

export interface IRequestLoginAction extends Action {
    type: AuthActionType.REQUEST_LOGIN;
    item: LoginRequest;
}
export interface ICallbackLoginAction extends Action {
    type: AuthActionType.CALLBACK_LOGIN;
    isSuccess: boolean;
    item?: LoginResponse;
}

export interface IRequestLogoutAction extends Action {
    type: AuthActionType.REQUEST_LOGOUT;
}
export interface ICallbackLogoutAction extends Action {
    type: AuthActionType.CALLBACK_LOGOUT;
    isSuccess: boolean;
}

export interface IRequestPasswordResetAction extends Action {
    type: AuthActionType.REQUEST_PASSWORD_RESET;
    item: PasswordResetRequest;
}
export interface ICallbackPasswordResetAction extends Action {
    type: AuthActionType.CALLBACK_PASSWORD_RESET;
    isSuccess: boolean;
}

export interface IRequestCreateCustomerAction extends Action {
    type: AuthActionType.REQUEST_CREATE_CUSTOMER;
    item: CreateCustomerRequest;

}
export interface ICallbackCreateCustomerAction extends Action {
    type: AuthActionType.CALLBACK_CREATE_CUSTOMER;
    isSuccess: boolean;
    item?: CreateCustomerResponse,
}

export interface IRequestApplyClientAction extends Action {
    type: AuthActionType.REQUEST_APPLY_CLIENT;
    item: ApplyClientRequest;
}
export interface ICallbackApplyClientAction extends Action {
    type: AuthActionType.CALLBACK_APPLY_CLIENT;
    isSuccess: boolean;
}

export interface IRequestGetMeAction extends Action {
    type: AuthActionType.REQUEST_GET_ME;
}
export interface ICallbackGetMeAction extends Action {
    type: AuthActionType.CALLBACK_GET_ME;
    isSuccess: boolean;
    item?: GetMeResponse;
}

export type AuthAction =
    IObserveAuthListenerAction |
    IRequestOnAuthListenerAction |
    ICallbackOnAuthListenerAction |
    IRequestOffAuthListenerAction |
    ICallbackOffAuthListenerAction |
    IRequestLoginAction |
    ICallbackLoginAction|
    IRequestLogoutAction |
    ICallbackLogoutAction|
    IRequestPasswordResetAction |
    ICallbackPasswordResetAction |
    IRequestCreateCustomerAction |
    ICallbackCreateCustomerAction |
    IRequestApplyClientAction |
    ICallbackApplyClientAction |
    IRequestGetMeAction |
    ICallbackGetMeAction

export interface IAuthActionCreator {
    observeAuthListenerAction(isSuccess: boolean, item?: ObserveAuthListenerResponse) : IObserveAuthListenerAction;

    requestOnAuthListenerAction(item: OnAuthListenerRequest): IRequestOnAuthListenerAction;
    callbackOnAuthListenerAction(isSuccess: boolean, item?: OnAuthListenerResponse): ICallbackOnAuthListenerAction;

    requestOffAuthListenerAction(item: OffAuthListenerRequest): IRequestOffAuthListenerAction;
    callbackOffAuthListenerAction(isSuccess: boolean, item?: OffAuthListenerResponse): ICallbackOffAuthListenerAction;

    requestLoginAction(item: LoginRequest): IRequestLoginAction;
    callbackLoginAction(isSuccess: boolean, item?: LoginResponse): ICallbackLoginAction;

    requestLogoutAction(): IRequestLogoutAction;
    callbackLogoutAction(isSuccess: boolean): ICallbackLogoutAction;

    requestPasswordResetAction(item: PasswordResetRequest,): IRequestPasswordResetAction;
    callbackPasswordResetAction(isSuccess: boolean): ICallbackPasswordResetAction;

    requestCreateCustomerAction(item: CreateCustomerRequest): IRequestCreateCustomerAction;
    callbackCreateCustomerAction(isSuccess: boolean, item?: CreateCustomerResponse): ICallbackCreateCustomerAction;

    requestApplyClientAction(item: ApplyClientRequest,): IRequestApplyClientAction;
    callbackApplyClientAction(isSuccess: boolean): ICallbackApplyClientAction;

    requestGetMeAction(): IRequestGetMeAction;
    callbackGetMeAction(isSuccess: boolean, item?: GetMeResponse): ICallbackGetMeAction;

}

class ActionCreator implements IAuthActionCreator {

    public observeAuthListenerAction(isSuccess: boolean, item?: ObserveAuthListenerResponse): IObserveAuthListenerAction {
        return {
            type: AuthActionType.OBSERVE_AUTH_LISTENER,
            isSuccess,
            item,
        }
    }

    public requestOnAuthListenerAction(item: OnAuthListenerRequest): IRequestOnAuthListenerAction {
        return {
            type: AuthActionType.REQUEST_ON_AUTH_LISTENER,
            item,
        }
    }

    public callbackOnAuthListenerAction(isSuccess: boolean, item?: OnAuthListenerResponse): ICallbackOnAuthListenerAction {
        return {
            type: AuthActionType.CALLBACK_ON_AUTH_LISTENER,
            isSuccess,
            item,
        }
    }

    public requestOffAuthListenerAction(item: OffAuthListenerRequest): IRequestOffAuthListenerAction {
        return {
            type: AuthActionType.REQUEST_OFF_AUTH_LISTENER,
            item,
        }
    }

    public callbackOffAuthListenerAction(isSuccess: boolean, item?: OffAuthListenerResponse): ICallbackOffAuthListenerAction {
        return {
            type: AuthActionType.CALLBACK_OFF_AUTH_LISTENER,
            isSuccess,
            item,
        }
    }

    public requestLoginAction = (item: LoginRequest): IRequestLoginAction => {
        return {
            type: AuthActionType.REQUEST_LOGIN,
            item,
        };
    };
    public callbackLoginAction = (
        isSuccess: boolean,
        item?: LoginResponse,
        ): ICallbackLoginAction => {
        return {
            type: AuthActionType.CALLBACK_LOGIN,
            isSuccess,
            item,
        };
    };

    public requestLogoutAction = (): IRequestLogoutAction => {
        return {
            type: AuthActionType.REQUEST_LOGOUT,
        };
    };
    public callbackLogoutAction = (
        isSuccess: boolean,
        ): ICallbackLogoutAction => {
        return {
            type: AuthActionType.CALLBACK_LOGOUT,
            isSuccess,
        };
    };

    public requestPasswordResetAction = (item: PasswordResetRequest,): IRequestPasswordResetAction => {
        return {
            type: AuthActionType.REQUEST_PASSWORD_RESET,
            item,
        };
    };
    public callbackPasswordResetAction = (
        isSuccess: boolean,
        ): ICallbackPasswordResetAction => {
        return {
            type: AuthActionType.CALLBACK_PASSWORD_RESET,
            isSuccess,
        };
    };

    public requestCreateCustomerAction = (
        item: CreateCustomerRequest,
    ): IRequestCreateCustomerAction => {
        return {
            type: AuthActionType.REQUEST_CREATE_CUSTOMER,
            item,
        };
    };
    public callbackCreateCustomerAction = (
        isSuccess: boolean,
        item?: CreateCustomerResponse,
    ): ICallbackCreateCustomerAction => {
        return {
            type: AuthActionType.CALLBACK_CREATE_CUSTOMER,
            isSuccess,
            item,
        };
    };

    public requestApplyClientAction = (item: ApplyClientRequest,): IRequestApplyClientAction => {
        return {
            type: AuthActionType.REQUEST_APPLY_CLIENT,
            item,
        };
    };
    public callbackApplyClientAction = (
        isSuccess: boolean,
        ): ICallbackApplyClientAction => {
        return {
            type: AuthActionType.CALLBACK_APPLY_CLIENT,
            isSuccess,
        };
    };

    public requestGetMeAction = (): IRequestGetMeAction => {
        return {
            type: AuthActionType.REQUEST_GET_ME,
        };
    };
    public callbackGetMeAction = (
        isSuccess: boolean,
        item?: GetMeResponse,
    ): ICallbackGetMeAction => {
        return {
            type: AuthActionType.CALLBACK_GET_ME,
            isSuccess,
            item,
        };
    };

}

export const createAuthActionCreator = (): IAuthActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/auth_action.ts